import React from "react";
import { useLocation } from "react-router-dom";

export const pathname = ["/FaqGovernmentActRegulations/", "/FaqGovernmentSecurities/", "/FaqPrimaryIssuances/", "/FaqGoldBonds/", "/FaqFrsb/", "/FaqNdsOmSecondaryMarket/", "/FaqRbiRetailDirect/",
    "/FaqGovernmentActRegulations", "/FaqGovernmentSecurities", "/FaqPrimaryIssuances", "/FaqGoldBonds", "/FaqFrsb", "/FaqNdsOmSecondaryMarket", "/FaqRbiRetailDirect"
]

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}


const UrlParamChecker = () => {


    const location = useLocation();
    let query = useQuery();


    if (location.search === "?app=true" || query.get("app") === "true") return true
    else return false
}


export const UrlMobileChecker = () => {
    let query = useQuery();
    if (query.get("mobile") === "true") {
        if (query.get("secondary") === "true") return "secondarymobile"
        else if (query.get("primary") === "true") return "primarymobile"
        else return "mobilelink"
    }
    else return "desktoplink"
}
export const UrlParamFaq = () => {


    const location = useLocation();

    if (pathname.includes(location.pathname)) return true
    else return false
}

export default UrlParamChecker;
